import {
  loggedIn,
  checkoutIsSubmittable,
  invoiceNeedsPaying,
} from '../../../routes/conditional';
import paths from '../../../routes/paths';
import {
  submitExemption,
  clearSubmitDeclarationError,
} from '../../../redux/modules/checkout';
import {
  getCheckoutSelectedExemptionCode,
  getCheckoutExemptionIsSkipped,
  getCheckoutOrderId,
  getPendingOrdersCurrentCCStoreAddressForOrder,
} from '../../../redux/modules/root-reducer';

export const page = {
  path: paths.checkout.declaration,
  isAllowed: [loggedIn, checkoutIsSubmittable, invoiceNeedsPaying],
};

export const checkoutDeclaration = {
  actionPath: '/actions/exemption-declare',
  action: ({ state }) =>
    submitExemption(
      getCheckoutOrderId(state),
      getCheckoutSelectedExemptionCode(state),
      getCheckoutExemptionIsSkipped(state),
      getPendingOrdersCurrentCCStoreAddressForOrder(state)
    ),
};

export const clearDeclarationError = {
  actionPath: '/actions/clear-exemption-declaration-error',
  action: () => clearSubmitDeclarationError(),
};
